var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import * as React from "react";
import { ErrorView } from "../components/core/09-views/02-pages/Error";
/**
 *
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    /**
     *
     * @param props
     */
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
        };
        return _this;
    }
    /**
     *
     * @param _error
     */
    ErrorBoundary.getDerivedStateFromError = function (_error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    };
    /**
     *
     * @param _error
     * @param info
     */
    ErrorBoundary.prototype.componentDidCatch = function (_error, info) {
        // You can also log the error to an error reporting service
        var errorInfo = "\n        Error Information:\n        ".concat(info.componentStack, "\n        ");
        var clientInfo = "\n        ClientInformation:\n        AppVersion: ".concat(navigator.appVersion, "\n        AppCodeName: ").concat(navigator.appCodeName, "\n        AppName: ").concat(navigator.appName, "\n        Vendor: ").concat(navigator.vendor, "\n        UserAgent: ").concat(navigator.userAgent, "\n        cookieEnabled: ").concat(navigator.cookieEnabled.toString(), "\n        ");
        var date = "Date: ".concat(new Date());
        var allInfo = "\n            ".concat(errorInfo, "\n            ").concat(clientInfo, "\n            ").concat(date, "\n        ");
        var buffData = Buffer.from(allInfo);
        this.setState({
            hasError: true,
            errorInfo: buffData.toString("base64"),
        });
    };
    /**
     *
     */
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (React.createElement(ErrorView, { info: this.state.errorInfo }));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
